import { FC } from 'react';
import { DashboardUtils } from '@/features/dashboard/utils/dashboardUtils';

type Props = {
	value: number;
};

const DashboardChartChangeIndicator: FC<Props> = ({ value }) => {
	const status = value > 0 ? 'positive' : value < 0 ? 'negative' : 'equal';

	const { icon: Icon, colorClass, sign } = DashboardUtils.getIndicatorConfig[status];

	return (
		<div className={`flex items-center gap-1 ${colorClass}`}>
			<Icon className={colorClass} />
			{`${sign}${value.toFixed(1)}%`}
		</div>
	);
};

export default DashboardChartChangeIndicator;
